import { render, staticRenderFns } from "./seaFreightDataStatisticsDetail.vue?vue&type=template&id=6b49b334&scoped=true"
import script from "./seaFreightDataStatisticsDetail.vue?vue&type=script&lang=js"
export * from "./seaFreightDataStatisticsDetail.vue?vue&type=script&lang=js"
import style0 from "./seaFreightDataStatisticsDetail.vue?vue&type=style&index=0&id=6b49b334&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b49b334",
  null
  
)

export default component.exports